import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController } from 'ionic-angular';
import { TakeawayServices } from "../../services";
import { Globals } from "../../../../globals";
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { AngularFirestore } from 'angularfire2/firestore';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';

/**
 * Generated class for the TakeawayOrdersRecoverPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'takeaway-orders-recover',
  templateUrl: 'takeaway-orders-recover.html',
})

export class TakeawayOrdersRecoverPage {
  tickets_array_take_away = [];
  activeAllRecover: boolean = false;
  loading_tickets: boolean = false;
  date_first: any;
  date_last: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals: Globals,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public translate: TranslateService,
    public afs: AngularFirestore) {
    this.date_first = moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss');
    this.date_last = moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss');

    this.loadList();
  }

  /**********************************************************/
  /*                        FUNCIONES                       */
  /**********************************************************/

  //funcion que carga la lista de pedidos para poder recuperar
  async loadList() {
    this.loading_tickets = false;
    this.tickets_array_take_away = await this.takeawayServices.getTakeawayTickets2Recover(this.globals.restaurant_uid, this.date_first, this.date_last);
    this.loading_tickets = true;
  }

  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('general-takeaway') + ' / ' + this.translate.instant('reservation-create-recuperar'),
      date_first: this.date_first,
      date_last: this.date_last,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.date_first = data.date_first;
        this.date_last = data.date_last;
        //
        this.loadList();
      }
    });
    profileModal.present();
  }

  //funcion que recupera la img del delivery
  getDeliveryImage(table) {
    if (table != undefined) {
      const delivery = this.takeawayServices.deliveries.find(t => t.name == table);
      if (delivery != undefined) {
        return delivery.img;
      }
    }
  }

  //funcion que activa todos los checkbox de todos los pedidos que se pueden recuperar
  activeAll() {
    for (let ticket of this.tickets_array_take_away) {
      if (!this.activeAllRecover) {
        ticket.active_recover = true;
      } else {
        ticket.active_recover = false;
      }
    }
  }

  //funcion que recupera los pedidos
  recover() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('general-recuperando-pedido'),
    });
    loadingPopup.present();
    for (let _ticket of this.tickets_array_take_away) {
      if (_ticket.active_recover) {
        //preparar ticket
        var ticket = {
          'amount': _ticket.amount,
          'created_at': _ticket.date,
          'date': _ticket.date,
          'delivery': _ticket.delivery,
          'list': _ticket.list,
          'number': _ticket.number,
          'payment': _ticket.payment,
          'payment_type': _ticket.payment_type,
          'updated_at': _ticket.date,
          'waiter': _ticket.waiter,
          'waiter_uid': _ticket.waiter_uid,
        }

        //insert table
        this.afs.collection('tables').add({
          'UID_RESTAURANT': this.globals.restaurant_uid,
          'cash_static': _ticket.cash_static,
          'cash_uid': _ticket.cash_uid,
          'created_at': _ticket.date,
          'customer_address': this.globals.ifVarEmpty(_ticket.customer.address),
          'customer_email': this.globals.ifVarEmpty(_ticket.customer.email),
          'customer_name': this.globals.ifVarEmpty(_ticket.customer.name),
          'customer_phone': this.globals.ifVarEmpty(_ticket.customer.phone),
          'customer_uid': this.globals.ifVarEmpty(_ticket.customer_uid),
          'datetime_pickup_delivey': this.globals.ifVarEmpty(_ticket.datetime_pickup_delivey),
          'name': '',
          'notes': this.globals.ifVarEmpty(_ticket.delivery_notes),
          'persons': '',
          'size': 2,
          'state': 'closed',
          'ticket': ticket,
          'type': 'takeaway',
          'uid_room': '',
          'order_state': this.globals.ifVarEmpty(_ticket.order_state),
          'deliverect_order_id': this.globals.ifVarEmpty(_ticket.deliverect_order_id),
          'deliverect_channel_order_id': this.globals.ifVarEmpty(_ticket.deliverect_channel_order_id),
          'deliverect_receipt_id': this.globals.ifVarEmpty(_ticket.deliverect_receipt_id),
          'deliverect_order_state': this.globals.ifVarEmpty(_ticket.deliverect_order_state),
          'deliverect_delivery_cost': this.globals.ifVarEmpty(_ticket.deliverect_delivery_cost),
          'deliverect_channel_order_display_id': this.globals.ifVarEmpty(_ticket.deliverect_channel_order_display_id),
        }).then(async doc => {
          //reedit table uid orders to new table uid
          //get orders
          var orders = await this.takeawayServices.getOrdersfs(this.globals.restaurant_uid, _ticket.table_uid);
          for (let order of orders) {
            this.afs.collection('orders').doc(order.UID).update({
              'table_uid': doc.id,
              'show_order': true
            });
          }
          //update ticket with new table uid
          this.afs.collection('tickets').doc(_ticket.UID).update({
            'table_uid': doc.id,
          });
        });
      }
    }

    loadingPopup.dismiss();
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-orders/takeaway-orders-recover/takeaway-orders-recover.ts